// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".field[data-v-30e8f2ac]{padding:.5rem 1rem;width:100%}textarea[data-v-30e8f2ac]{resize:vertical;min-height:8rem;min-width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
